module.exports = __webpack_public_path__ + "img/boton_ordenar_categoria.1f9fcfff.svg";